module.exports = __webpack_public_path__ + "static/media/biglietti-logo.d693cd32.svg";